<template lang="pug">
div.mainh
	div#navbar-top.navbar.navbar-expand-lg.navbar-dark.bg-default( v-observe-visibility="visibilityChanged")
		.container
			//#navbar_global.navbar-collapse.collapse
				ul.navbar-nav.navbar-nav-hover.align-items-center
					li.nav-item
						a.nav-link(href="tel:4432041123", role='button')
							i.fas.fa-phone
							span.nav-link-inner--text (443) 204 1123
					li.nav-item
						router-link.nav-link(to="/contacto#ubicaciones")
							i.far.fa-building
							span.nav-link-inner--text Oriente Cuatro 20, Cd Industrial.
					li.nav-item
						router-link.nav-link(to="/horario", role='button')
							i.far.fa-clock
							span.nav-link-inner--text Lunes a Viernes 09:00 a 18:00 
				//-ul.navbar-nav.align-items-lg-center.ml-lg-auto
					li.nav-item
						button.btn.btn-primary(@click='modalCotiza=true') Cotizar
	header
		base-nav#navbar-main( :class="topBar? 'topBar': 'nottopBar'" transparent type='' effect='light' expand)
			router-link.navbar-brand.mr-lg-5(slot='brand', to='/')
				img(src='../assets/img/brand/logo-blanco-puro.png', alt='logo' style="padding-left: 8px")
			.row(slot='content-header', slot-scope='{closeMenu}')
				.col-6.collapse-brand
					router-link(to="/")
						img(src='../assets/img/brand/logo-limpio.png' style="padding-left: 5px")
				.col-6.collapse-close
					close-button(@click='closeMenu')
			ul.navbar-nav.navbar-nav-hover.align-items-lg-center(slot-scope='{closeMenu}')
				li.nav-item
					router-link.nav-link(to="/nosotros", data-toggle='dropdown', role='button')
						i.d-lg-none.fas.fa-lg.fa-users
						span.nav-link-inner--text(@click='closeMenu') Nosotros
				li.nav-item
					router-link.nav-link(to="/galeria", data-toggle='dropdown', role='button')
						i.d-lg-none.fas.fa-lg.fa-image
						span.nav-link-inner--text(@click='closeMenu') Galería
				li.nav-item
					base-dropdown.nav-item(tag='li')
						router-link.nav-link(slot='title', to="/productos", data-toggle='dropdown', role='button')
							i.d-lg-none.fas.fa-lg.fa-shopping-bag
							span.nav-link-inner--text Productos
						router-link.dropdown-item(to='/cajas' @click='closeMenu') Cajas
						router-link.dropdown-item(to='/rafias' @click='closeMenu') Rafias
						router-link.dropdown-item(to='/esquineros' @click='closeMenu') Esquineros
				li.nav-item
					router-link.nav-link(to="/contacto", data-toggle='dropdown', role='button')
						i.d-lg-none.fas.fa-lg.fa-address-book
						span.nav-link-inner--text(@click='closeMenu') Contacto
				li.nav-item
					router-link.nav-link(to="/bolsa", data-toggle='dropdown', role='button')
						i.fas.fa-lg.fa-briefcase.d-lg-none
						span.nav-link-inner--text(@click='closeMenu') Bolsa de trabajo
				ul.navbar-nav.align-items-lg-center.ml-lg-auto
					//li.nav-item
						a.nav-link.nav-link-icon(href='https://www.facebook.com/plastomex', target='_blank', rel='noopener', data-toggle='tooltip', title='Síguenos en Facebook')
							i.fab.fa-lg.fa-facebook-square
							span.nav-link-inner--text.d-lg-none Facebook
					//li.nav-item
						a.nav-link.nav-link-icon(href='https://wa.me/524433951818', target='_blank', rel='noopener', data-toggle='tooltip', title='Enviar mensaje por Whatsapp')
							i.fab.fa-lg.fa-whatsapp
							span.nav-link-inner--text.d-lg-none Enviar mensaje
					li.nav-item
						button.btn.btn-primary( :class="topBar? 'btnproUp': 'btnpro'", @click='modalCotiza=true') Cotizar



	modal(:show.sync='modalCotiza', body-classes='p-0', modal-classes='modal-dialog-centered modal-sm')
		card.border-0(type='secondary', shadow, header-classes='bg-white pb-5', body-classes='px-lg-5 py-lg-5') 
			template
				.text-center.text-muted.mb-4
					small Ingresa tus datos
				form(role='form' @submit.prevent="cotizar")
					base-input(
						:required="true"
						placeholder='Nombre', 
						name="nombre"
						addon-left-icon='ni ni-circle-08'
						v-model='cotizacion.nombre')
					base-input(
						:required='true'
						placeholder='Empresa', 
						name="empresa"
						addon-left-icon='ni ni-building'
						v-model='cotizacion.empresa')
					base-input(
						required
						placeholder='Producto', 
						name="producto"
						addon-left-icon='ni ni-app'
						v-model='cotizacion.producto')
					base-input(
						:required='true'
						placeholder='Volumen', 
						name="volumen"
						addon-left-icon='ni ni-basket'
						v-model='cotizacion.vol')
					base-input(
						required
						placeholder='Teléfono', 
						name="tel"
						addon-left-icon='fa fa-phone'
						pattern="[0-9]{10}"
						v-model='cotizacion.tel')
					base-input.mb-3(
						required
						placeholder='Email',
						type='email'
						name="email" 
						addon-left-icon='ni ni-email-83'
						v-model="cotizacion.email")
					input.btn.btn-primary.my-4(type="submit" value="Cotizar") 

			base-alert.alert-dismissible(:type='alert.type', v-if='alert')
				span.alert-inner--icon
					i.ni.ni-like-2
				span.alert-inner--text
					strong ¡{{ alert.strong }}!
					|  {{alert.msg}}
				button.close(type='button', @click.stop='alert=false' data-dismiss='alert', aria-label='Close')
					span(aria-hidden='true' ) ×
</template>

<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import Modal from "@/components/Modal.vue";

export default {
  components: {
	BaseNav,
	CloseButton,
	BaseDropdown,
	Modal
  },
  data(){
	  return{
		  modalCotiza:false,
		  topBar: true,
		  cotizacion:{},
		  alert: false,
	  }
  },
  methods:{
	  clsNotTop(){
		  //console.log('Ya bajó')
	  },
	  clsTop(){
		  //console.log('Pegada')
	  },
	  visibilityChanged (isVisible, entry) {
        this.topBar = isVisible
        //console.log(entry); console.log(this.topBar)
      },
		cotizar(){
			//if ( !(this.cotizacion.nombre && this.cotizacion.empresa) ) console.log('si fucniona');
			
			//console.log(JSON.stringify(this.cotizacion))

			fetch('https://mail.plastomex.com/sendmail', {
				method:'post',
				body: JSON.stringify( {...this.cotizacion, from:'cotizar'}),
				headers:{
					'Content-Type': 'application/json'
				},
				mode: 'cors'
			})
			.then(response => response.json())
			.catch(error => {
				this.$swal('Error','Error al enviar el mensaje','error')
				console.error('Error:', error)
				})
			.then( data => {
				if(data.messageId)
					this.$swal('Enviado','El mensaje se envió correctamente','success');
				//console.log(data)
				//this.alert = {msg:'Correo enviado con exito', strong:'Exito', type:'success'},
				this.cotizacion = {}
				this.modalCotiza=false
			})
		}
  }
};
</script>
<style lang="scss">
.form-control, .form-control:focus{
	color: #333 !important;
}
</style>
